export default {
    names: {
        hour: "hour",
        minute: "minute",
        day: "day",
    },
    objects: {
        offline_update: "Disable check for updates",
        time: "Time",
        type_time: "Time format",
        button_save: "Save",
        period: "Update check period",
        address: "Server address for updates",
        setting: "Setting"
    },
    notification: {
        load_error: "Load error",
        incorrect_data: "Value cannot be 0",
        incorrect_time: "Value can be greater 0",
        download_ok: "Changes saved",
        download_error: "Save error",
    },
}